// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"1bef058b","629":"a6fc9f5f","869":"d1c6690c","974":"2be7b50c"}[chunkId] + ".chunk.js";
};